import { useStyles } from '@archipro-design/aria';
import { Loader } from '@archipro-design/icons';
import { Animation } from '@fluentui/react-northstar';
import * as S from '~/modules/design-board/component/upload/UploadErrorTile.style';

const UploadLoadingTile = () => {
    const { css } = useStyles();

    return (
        <div>
            <div className={css(S.LoadingTileLoader)}>
                <Animation name="rotateUltraSlow">
                    <Loader />
                </Animation>
            </div>
            <div className={css(S.LoadingTileText)}>-</div>
        </div>
    );
};

export default UploadLoadingTile;
